<template>
  <div>
    <p v-if="submitError" class="alert alert-danger">{{submitError}}</p>
    <form name="loginForm" id="login-form" class="form-area auth dynamic" v-on:submit.prevent="submit" novalidate>
      <div class="form-row">
        <p class="field-error" :class="{ 'show-error' : errors.current === 'email' }">Grr... That is not a valid email</p>
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'email' }">
          <input
            v-model="formData.email"
            id="email"
            name="email"
            type="text"
            :class="{'active': (activeField.email || !!formData.email)}"
            @focus="emailFocus"
            required>
          <label for="email">Email</label>
        </div>
      </div>
      <div class="form-row">
        <p class="field-error" :class="{ 'show-error' : errors.current === 'password' }">Grr... Please enter a valid password</p>
        <div class="input-wrap" :class="{ 'show-error' : errors.current === 'password' }">
          <input
            v-model="formData.password"
            id="password"
            name="password"
            type="password"
            :class="{'active': (activeField.password || !!formData.password)}"
            @focus="passwordFocus"
            @blur="passwordBlur"
            required>
          <label for="password">Password</label>
        </div>
      </div>
      <submit-button :finished="finished" :submitting="submitting" @submit="submit">
        <slot name="btn-copy">
          Log In
        </slot>
      </submit-button>
    </form>
  </div>
</template>

<script>
import marketing from '../../services/marketing'
import submitButton from '@/components/submit-button/submit-button'
import is from 'is_js'
import validator from '../../mixins/validator.js'
import { eventBus } from '@/services/bus.js'

export default {
  name: 'login-form',
  components: {
    'submit-button': submitButton
  },
  mixins: [validator],
  data () {
    return {
      is: is,
      activeField: {
        email: false,
        password: false
      },
      formData: {
        email: '',
        password: ''
      },
      submitted: false,
      submitting: false,
      finished: false,
      submitError: ''
    }
  },
  computed: {
    validations: function () {
      return {
        'email': [this.formData.email, this.is.email(this.formData.email)],
        'password': [this.formData.password, this.formData.password.length > 7]
      }
    }
  },
  created: function () {},
  methods: {
    emailFocus: function () {
      this.activeField.email = true
      eventBus.$emit('emailInputFocus')
    },
    passwordFocus: function () {
      this.activeField.password = true
      eventBus.$emit('passwordInputFocus')
    },
    passwordBlur: function () {
      eventBus.$emit('passwordInputBlur')
    },
    makeRequest: function () {
      if (this.submitting) return
      this.submitting = true
      this.submitError = ''
      let data = {
        username: this.formData.email,
        password: this.formData.password,
        withUserDetails: true,
        v: this.$route.query.v || 'web-1.0'
      }
      this.$store.dispatch('login', data).then((response) => {
        marketing.removeMarketingCookies()
        this.submitting = false
        this.finished = true
      }).catch((error) => {
        if (error.response && error.response.status === 429) {
          this.submitError = 'Hold your bears! You\'ve tried that too many times. Please try again in a few minutes.'
        } else {
          this.submitError = 'We can\'t seem to find that email and password combination, try another?'
        }
        this.submitting = false
      })
    },
    submit: function () {
      this.submitted = true
      if (this.errors.all.length === 0) {
        this.makeRequest()
      }
    }
  },
  watch: {
    'formData.email': {
      handler: function () {
        eventBus.$emit('emailInputTyping', this.formData.email.length)
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="./login-form.styl" >



// WEBPACK FOOTER //
// src/components/login-form/login-form.vue